// src/pages/transportations/CreateTransportation.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditTransportation from "../../components/transportations/FormAddEditTransportation";

const CreateTransportation = () => {
    const navigate = useNavigate();

    const handleSuccess = () => {
        navigate("/transportations");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditTransportation
                isEdit={false}
                currentData={null}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default CreateTransportation;
